.wrapper {
  position: relative;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
}

.grid {
  display: flex;
  gap: 1rem;
  padding-inline: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 0.75rem;
  overflow: auto;
  cursor: grab;

  &:-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.gridCenter {
  padding-top: 1rem;
  margin-inline: -1.5rem;
}

.title {
  font-size: 12px;
  font-weight: 400;
}

.heading {
  font-size: 40px;
  font-weight: 500;
}

.previousPeriodText,
.trendText {
  font-size: var(--font-size-helptext);
}

.previousPeriodContainer,
.trendContainer {
  display: flex;
  gap: 0.35rem;
  align-items: center;
}

.trendBadge,
.previousPeriodBadge {
  align-self: flex-start;
}

.card {
  min-width: 220px;
  max-width: 220px;
  min-height: 160px;
  overflow: hidden;
  color: var(--top-widget-card-color);
  text-align: left;
  background: var(--top-widget-card-background);
  border: 1px solid var(--top-widget-border-color);
  border-radius: 12px;
  box-shadow: var(--top-widget-card-shadow);
  transition: background-color 0.1s ease-in-out;

  &:hover {
    background-color: var(--top-widget-card-background-hover);
    border: 1px solid var(--top-widget-border-color-hover);
  }
}

.cardContent {
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: space-between;
  height: 100%;
  padding: 1rem;
}

.loadingEnter {
  opacity: 0;
}

.loadingEnterActive {
  opacity: 1;
  transition: opacity 500ms;
}

@keyframes glow {
  50% {
    opacity: 0.75;
  }

  0%,
  100% {
    opacity: 1;
  }
}

.loading {
  &,
  & > * {
    animation-name: glow;
    animation-duration: 1500ms;
    animation-iteration-count: infinite;
  }
}

.download {
  color: var(--white);
  cursor: pointer;
  background-color: var(--pink-700);
  background-image: url("@/assets/images/artsy-square-pink.png");
  background-repeat: no-repeat;
  background-position: top right;
  transition: background-color 200ms;

  & > * {
    justify-content: space-between;
  }

  &:hover {
    background-color: var(--pink-800);
  }
}

.lockup {
  display: flex;
  align-items: flex-end;
}

.trend {
  font-weight: var(--font-weight-light);
  color: var(--on-background);
}

.trendPositive {
  color: var(--blue-400);
}

.trendNeutral {
  color: var(--gray-400);
}

.trendNegative {
  color: var(--pink-600);
}

.sentimentPosGreen {
  color: var(--sentiment-positive);
}

.sentimentBar {
  display: flex;

  & > * {
    height: 10px;
  }
}

.positiveBg {
  background-color: var(--sentiment-positive);
}

.neutralBg {
  background-color: var(--gray-300);
}

.negativeBg {
  background-color: var(--sentiment-negative);
}

.positiveColor {
  color: var(--sentiment-positive);
}

.neutralColor {
  color: var(--gray-300);
}

.negativeColor {
  color: var(--sentiment-negative);
}

.header h2 {
  display: inline;
}

.episodeCount {
  display: inline;
  font-size: var(--font-size-subtitle-2);
  font-weight: var(--font-weight-light);
  color: var(--muted-old);
}

.numberName {
  display: inline;
  margin-left: 0.5rem;
  font-size: 12px;
}

.spinner {
  background: var(--white);
  fill: var(--pink-600);
}

.vertical {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.downloadIcon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  margin-left: auto;
  color: var(--pink-600);
  background-color: white;
  border-radius: 9999px;
}

.downloadText {
  margin-right: 0.5rem;
}

.insightsSummary {
  min-width: 430px;
  max-width: 430px;
}
